// extracted by mini-css-extract-plugin
export default {"national_id__input":"styles_national_id__input__6q3jD"};